var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.73524 7.58621H0.355699L6.94014 16L19 0L6.95625 11.473L3.73524 7.58621Z",
    fill: "#16140C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56504 16.3636L4.68931 14L0 20H3.75146L6.56504 16.3636Z",
    fill: "#16140C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31524 16.3636L9.19097 14L13.8803 20H10.1288L7.31524 16.3636Z",
    fill: "#16140C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossX);
export default __webpack_public_path__ + "static/media/cross-x.7f14890e3d6544edad78febae99216f7.svg";
export { ForwardRef as ReactComponent };